import type { FestivalTheme } from '@mendikot/design-tokens';

/** Geometric festival emblems (no illustrations to license), drawn in a 100×100 box. */
export function EmblemShape({ emblem }: { emblem: FestivalTheme['emblem'] }) {
  switch (emblem) {
    case 'chakra':
      return (
        <g fill="none" stroke="currentColor" strokeWidth="3">
          <circle cx="50" cy="50" r="38" />
          <circle cx="50" cy="50" r="6" fill="currentColor" />
          {Array.from({ length: 24 }, (_, i) => {
            const a = (i * Math.PI * 2) / 24;
            return (
              <line
                key={i}
                x1={50}
                y1={50}
                x2={50 + 38 * Math.cos(a)}
                y2={50 + 38 * Math.sin(a)}
                strokeWidth="1.6"
              />
            );
          })}
        </g>
      );
    case 'diya':
      return (
        <g fill="currentColor">
          <path d="M50 12c8 12 10 20 6 28-2 4-4 6-6 6s-4-2-6-6c-4-8-2-16 6-28z" />
          <path d="M14 56h72c-4 18-18 28-36 28S18 74 14 56z" />
          <rect x="40" y="84" width="20" height="5" rx="2" />
        </g>
      );
    case 'lotus':
      return (
        <g fill="currentColor">
          <path d="M50 18c10 14 12 34 0 54-12-20-10-40 0-54z" />
          <path d="M22 34c16 4 26 20 26 38-18-4-28-20-26-38z" opacity="0.85" />
          <path d="M78 34c-16 4-26 20-26 38 18-4 28-20 26-38z" opacity="0.85" />
          <path d="M8 56c14-2 30 6 38 18-16 4-32-4-38-18z" opacity="0.7" />
          <path d="M92 56c-14-2-30 6-38 18 16 4 32-4 38-18z" opacity="0.7" />
          <rect x="22" y="78" width="56" height="4" rx="2" />
        </g>
      );
    case 'mandala':
      return (
        <g fill="currentColor">
          {Array.from({ length: 12 }, (_, i) => (
            <ellipse
              key={i}
              cx="50"
              cy="24"
              rx="7"
              ry="16"
              transform={`rotate(${i * 30} 50 50)`}
              opacity="0.85"
            />
          ))}
          <circle cx="50" cy="50" r="12" />
        </g>
      );
    case 'kite':
      return (
        <g fill="currentColor">
          <path d="M50 8l26 32-26 40-26-40z" />
          <path d="M50 80c-4 6 6 8 0 14" fill="none" stroke="currentColor" strokeWidth="3" />
        </g>
      );
    case 'star':
      return (
        <path
          fill="currentColor"
          d="M50 6l9 26 27-6-19 20 19 20-27-6-9 26-9-26-27 6 19-20-19-20 27 6z"
        />
      );
    case 'tree':
      return (
        <g fill="currentColor">
          <path d="M50 8l20 26H58l18 22H62l20 24H18l20-24H24l18-22H30z" />
          <rect x="45" y="80" width="10" height="12" />
        </g>
      );
    case 'leaf':
      return (
        <path fill="currentColor" d="M18 82C14 40 42 14 86 14c0 44-26 72-68 68zM22 78L70 30" />
      );
  }
}
